import { useAuth } from 'context/AuthProvider.js';
import { httpClient } from 'helpers/HttpClient.js';
import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, FormControl, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { ApiEndpoint } from 'helpers/ApiEndPoint.js';
import PropTypes from 'prop-types';
const URI = ApiEndpoint + 'configuration/';

const EditTipoProductoQueja = ({ idTipoProducto, closeModal }) => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [tipoProducto, setTipoProducto] = useState({
    clave: '',
    descripcion: ''
  });

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors }
  } = useForm();

  const getProductType = async () => {
    setTipoProducto(null);

    httpClient(
      'GET',
      URI + 'tiposproducto/' + idTipoProducto,
      {},
      userData.token
    )
      .then(function (response) {
        if (!response.data.error) {
          setValue('clave', response.data.clave);
          setValue('descripcion', response.data.descripcion);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };

  const onSubmit = data => {
    console.log(data);

    if (idTipoProducto > 0) {
      httpClient(
        'put',
        URI + 'tiposproducto/' + idTipoProducto,
        {
          clave: data.clave,
          descripcion: data.descripcion,
          idusuario: 1
        },
        userData.token
      )
        .then(function (response) {
          if (!response.data.error) {
            closeModal();
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {});
    } else {
      httpClient(
        'POST',
        URI + 'tiposproducto',
        {
          clave: data.clave,
          descripcion: data.descripcion,
          idusuario: 1
        },
        userData.token
      )
        .then(function (response) {
          if (!response.data.error) {
            closeModal();
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {});
    }
  };
  useEffect(() => {
    if (idTipoProducto > 0) getProductType();
  }, []);
  return (
    <Card style={{ width: '100%' }}>
      <Card.Body>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Col>
              <Form.Group className="mb-4">
                <Form.Label>Clave</Form.Label>
                <FormControl
                  {...register('clave', {
                    required: 'Clave es requerido',
                    minLength: {
                      value: 4,
                      message: 'La Clave debe tener al menos 4 caracteres'
                    },
                    maxLength: {
                      value: 4,
                      message: 'La Clave debe tener maximo 4 caracteres'
                    }
                  })}
                  type="text"
                  defaultValue={tipoProducto?.clave}
                  isInvalid={!!errors.clave}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.clave?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-4">
                <Form.Label>Descripcion</Form.Label>
                <FormControl
                  {...register('descripcion', {
                    required: 'Descripcion es requerido',
                    minLength: {
                      value: 3,
                      message: 'Descripcion debe tener al menos 4 caracteres'
                    },
                    maxLength: {
                      value: 30,
                      message: 'Descripcion debe tener máximo 30 caracteres'
                    }
                  })}
                  type="text"
                  defaultValue={tipoProducto?.descripcion}
                  isInvalid={!!errors.descripcion}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.descripcion?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col>
              <Button type="submit" color="primary" size="sm">
                Guardar
              </Button>
            </Col>
          </Row>
        </Form>
      </Card.Body>
    </Card>
  );
};
EditTipoProductoQueja.propTypes = {
  idTipoProducto: PropTypes.number.isRequired,
  closeModal: PropTypes.func
};

export default EditTipoProductoQueja;
